<template>
  <div class="filters">
    <!--Selected-->
    <div class="columns" v-for="(item, index) in selections">
      <div class="column is-3">
        <b-select v-model="selections[index]" expanded disabled>
          <option v-for="opt in options" :value="opt">{{opt.name}}</option>
        </b-select>
      </div>
      <div class="column is-8">
        <div v-if="item.type == 'text'">
          <b-input v-model="item.value"></b-input>
        </div>
        <div v-if="item.type == 'tags'">
          <b-taginput placeholder="Filter"
                      autocomplete
                      type="is-primary"
                      v-model="selections[index].value"
                      :data="sortedFilters[selections[index].key]"
                      @typing="sortFilters($event, selections[index].key, index)"
                      open-on-focus>
          </b-taginput>
        </div>
      </div>
      <div class="column is-1">
        <button class="button" @click="Remove(item)">
          <i class="fas fa-times-circle"></i>
        </button>
      </div>
    </div>
    <!--Filters-->
    <div class="columns">
      <div class="column is-3">
        <b-select placeholder="Filter" v-model="selection" expanded>
          <option v-for="opt in UnusedOptions" :value="opt">{{opt.name}}</option>
        </b-select>
      </div>
      <div class="column is-8">
        <div v-if="selection.type == 'text'">
          <b-input v-model="selection.value" @keyup.native.enter="Add"></b-input>
        </div>
        <div v-if="selection.type == 'tags'">
          <b-taginput placeholder="Filter"
                      autocomplete
                      type="is-primary"
                      v-model="selection.value"
                      :data="sortedFiltersDummy"
                      @typing="sortFiltersDummy"
                      open-on-focus
                      @add="Add">
          </b-taginput>
        </div>
      </div>
      <div class="column is-1">
        <button class="button" v-if="selection.type" @click="Add()">
          <i class="fas fa-plus-circle"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import generic from "@/filters/generic.json";
  import scoring from "@/filters/scoring.json";
  import auditLog from "@/filters/auditLog.json";
  export default {
    name: "filters",
    data() {
      return {
        options: [],
        selections: [],
        selection: {},
        sortedFilters: [],
        sortedFiltersDummy: [],
        filters: []
      }
    },
    watch: {
      'selection': {
        handler: function (n, o) {
          if (n === undefined) {
            this.selection = {};
            return;
          }

          if (this.selection.type == "text") { }
          else if (this.selection.type !== undefined) {
            this.$http.post("api/filter/" + n.key, { filter: null })
              .then(resp => {
                this.sortedFiltersDummy = resp.data;
              }).catch(err => {
                //this.$buefy.toast.open({
                //  message: "Please choose a filter.",
                //  type: "is-info"
                //});
              })
          }
        },
        deep: true
      }
    },
    computed: {
      UnusedOptions() {
        return this.options.filter(opt => !this.selections.some(s => s.key == opt.key));
      }
    },
    props: {
      "value": Array
    },
    methods: {
      LoadJson(json) {
        this.options = json;
      },
      Remove(item) {
        var i = this.selections.indexOf(item);
        if (i > -1) {
          this.selections.splice(i, 1);
          this.$emit("input", this.selections);
        }
      },
      Add() {
        if (this.selection.key !== undefined && this.selection.value !== undefined) {
          this.selections.push(this.selection);
          this.$emit("input", this.selections);
          this.sortedFilters[this.selection.key] = this.sortedFiltersDummy;
          this.selection = {};
        }
        else {
          this.$buefy.toast.open({
            message: "Enter a valid filter first",
            type: "is-info"
          });
        }
      },
      sortFiltersDummy(text) {
        this.$http.post("api/filter/" + this.selection.key, { filter: text })
          .then(resp => {
            this.sortedFiltersDummy = resp.data;
          }).catch(err => {
            this.$buefy.toast.open({
              message: "An error occured. Please try again later.",
              type: "is-danger"
            });
          })
      },
      sortFilters(text, key, index) {
        this.$http.post("api/filter/" + key, { filter: text })
          .then(resp => {
            //console.log(index);
            this.$set(this.sortedFilters, index, resp.data);
          }).catch(err => {
            this.$buefy.toast.open({
              message: "An error occured. Please try again later.",
              type: "is-danger"
            });
          })
      }
    },
    created() {
      this.selections = this.value;
      switch (this.$route.path) {
        case "/analytics/scores": {
          this.LoadJson(scoring);
          break;
        }
        case "/admin/auditlog": {
          this.LoadJson(auditLog);
          break;
        }
        default: {
          this.LoadJson(generic);
          break;
        }
      }
    }
  }
</script>
<style>
  .filters .columns {
    margin-bottom: 0px;
  }
</style>
